import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { showErrorMessage, handleError } from '../utils/Utility';
import * as messages from '../utils/Messages';
import axios from 'axios';
import { GetAuthentication, Logout } from './AccountService';

const API = axios.create({
	// baseURL: 'http://senc-api-test.sa-east-1.elasticbeanstalk.com/',
	 baseURL: 'http://api.senc.interlogtransportes.com.br/',
	// baseURL: 'https://localhost:5001/',
	// responseType: "json",
	timeout: 500000,
	headers: { 'Content-Type': 'application/json' },
});
API.interceptors.request.use(function(config) {
	let authentication = GetAuthentication();
	if (authentication != null) config.headers.Authorization = 'Bearer ' + authentication.token;
	return config;
});
API.interceptors.response.use(
	function(response) {
		return response;
	},
	function(error) {
		if (error.response !== null && error.response !== undefined)
			if (error.response.status === 401) {
				localStorage.removeItem('authentication');
				window.location.href = '/login?action=login';
			}
		return Promise.reject(error);
	}
);
export default API;

export const logisticRouteDataSource = new DataSource({
	store: new CustomStore({
		key: 'Id',
		load: function(loadOptions) {
			try {
				return API.get('/logisticRoutes', {
					params: {
						term: loadOptions.searchValue,
					},
				})
					.then(response => {
						return response.data.logisticRoutes;
					})
					.catch(error => {
						handleError(error, messages.errorListData);
					});
			} catch (e) {
				showErrorMessage('Ocorreu uma falha ao listar os rotas de carregamento.');
			}
		},
		byKey: function(key) {
			try {
				if (key) {
					return API.get('/logisticRoutes/' + key)
						.then(response => {
							return response.data;
						})
						.catch(error => {
							handleError(error, messages.errorListData);
						});
				} else {
					return null;
				}
			} catch (e) {
				showErrorMessage('Ocorreu uma falha ao retornar o registro.');
			}
		},
	}),
});
export const userDataSource = new DataSource({
	store: new CustomStore({
		key: 'Id',
		load: function(loadOptions) {
			try {
				return API.get('/users', {
					params: {
						term: loadOptions.searchValue,
						enabled: true,
					},
				})
					.then(response => {
						return response.data.users;
					})
					.catch(error => {
						handleError(error, messages.errorListData);
					});
			} catch (e) {
				showErrorMessage('Ocorreu uma falha ao listar os usuários.');
			}
		},
		byKey: function(key) {
			try {
				if (key) {
					return API.get('/users/' + key)
						.then(response => {
							return response.data;
						})
						.catch(error => {
							handleError(error, messages.errorListData);
						});
				} else {
					return null;
				}
			} catch (e) {
				showErrorMessage('Ocorreu uma falha ao retornar o registro.');
			}
		},
	}),
});

export const logisticRouteStatusDataSource = new DataSource({
	store: new CustomStore({
		key: 'Id',
		load: function(loadOptions) {
			try {
				return API.get('/transportLogisticRouteStatus', {
					params: {
						term: loadOptions.searchValue,
					},
				})
					.then(response => {
						return response.data;
					})
					.catch(error => {
						handleError(error, messages.errorListData);
					});
			} catch (e) {
				showErrorMessage('Ocorreu uma falha ao listar os status.');
			}
		},
		byKey: function(key) {
			try {
				return API.get('/transportLogisticRouteStatus/' + key)
					.then(response => {
						return response.data;
					})
					.catch(error => {
						handleError(error, messages.errorListData);
					});
			} catch (e) {
				showErrorMessage('Ocorreu uma falha ao retornar o registro.');
			}
		},
	}),
});
export const vehicleDataSource = new DataSource({
	store: new CustomStore({
		key: 'Id',
		load: function(loadOptions) {
			try {
				return API.get('/vehicles', {
					params: {
						term: loadOptions.searchValue,
						enabled: true,
					},
				})
					.then(response => {
						return response.data.vehicles;
					})
					.catch(error => {
						handleError(error, messages.errorListData);
					});
			} catch (e) {
				showErrorMessage('Ocorreu uma falha ao listar os veículos.');
			}
		},
		byKey: function(key) {
			try {
				if (key) {
					return API.get('/vehicles/' + key)
						.then(response => {
							return response.data;
						})
						.catch(error => {
							handleError(error, messages.errorListData);
						});
				} else {
					return null;
				}
			} catch (e) {
				showErrorMessage('Ocorreu uma falha ao retornar o registro.');
			}
		},
	}),
});
export const driverDataSource = new DataSource({
	store: new CustomStore({
		key: 'Id',
		load: function(loadOptions) {
			try {
				return API.get('/drivers', {
					params: {
						term: loadOptions.searchValue,
						enabled: true,
					},
				})
					.then(response => {
						return response.data.drivers;
					})
					.catch(error => {
						handleError(error, messages.errorListData);
					});
			} catch (e) {
				showErrorMessage('Ocorreu uma falha ao listar os motoristas.');
			}
		},
		byKey: function(key) {
			try {
				if (key) {
					return API.get('/drivers/' + key)
						.then(response => {
							return response.data;
						})
						.catch(error => {
							handleError(error, messages.errorListData);
						});
				} else {
					return null;
				}
			} catch (e) {
				showErrorMessage('Ocorreu uma falha ao retornar o registro.');
			}
		},
	}),
});
export const adminstrativeCompanyDataSource = new DataSource({
	store: new CustomStore({
		key: 'Id',
		load: function(loadOptions) {
			try {
				return API.get('/administrativeCompany', {
					params: {
						term: loadOptions.searchValue,
						enabled: true,
					},
				})
					.then(response => {
						return response.data.administrativeCompanies;
					})
					.catch(error => {
						handleError(error, messages.errorListData);
					});
			} catch (e) {
				console.log(e);
				showErrorMessage('Ocorreu uma falha ao listar as empresas.');
			}
		},
		byKey: function(key) {
			try {
				return API.get('/administrativeCompany/' + key)
					.then(response => {
						return response.data;
					})
					.catch(error => {
						handleError(error, messages.errorListData);
					});
			} catch (e) {
				showErrorMessage('Ocorreu uma falha ao retornar o registro.');
			}
		},
	}),
});
export const shipDataSource = new DataSource({
	store: new CustomStore({
		key: 'Id',
		load: function(loadOptions) {
			try {
				return API.get('/ships', {
					params: {
						term: loadOptions.searchValue,
						enabled: true,
					},
				})
					.then(response => {
						return response.data.ships;
					})
					.catch(error => {
						handleError(error, messages.errorListData);
					});
			} catch (e) {
				showErrorMessage('Ocorreu uma falha ao listar os navios.');
			}
		},
		byKey: function(key) {
			try {
				return API.get('/ships/' + key)
					.then(response => {
						return response.data;
					})
					.catch(error => {
						handleError(error, messages.errorListData);
					});
			} catch (e) {
				showErrorMessage('Ocorreu uma falha ao retornar o registro.');
			}
		},
	}),
});
export const customerDataSource = new DataSource({
	store: new CustomStore({
		key: 'Id',
		load: function(loadOptions) {
			try {
				return API.get('/customers', {
					params: {
						term: loadOptions.searchValue,
						enabled: true,
					},
				})
					.then(response => {
						return response.data.customers;
					})
					.catch(error => {
						handleError(error, messages.errorListData);
					});
			} catch (e) {
				showErrorMessage('Ocorreu uma falha ao listar os clientes.');
			}
		},
		byKey: function(key) {
			try {
				return API.get('/customers/' + key)
					.then(response => {
						return response.data;
					})
					.catch(error => {
						handleError(error, messages.errorListData);
					});
			} catch (e) {
				showErrorMessage('Ocorreu uma falha ao retornar o registro.');
			}
		},
	}),
});
export const productDataSource = new DataSource({
	store: new CustomStore({
		key: 'Id',
		load: function(loadOptions) {
			try {
				return API.get('/products', {
					params: {
						term: loadOptions.searchValue,
						enabled: true,
					},
				})
					.then(response => {
						return response.data.products;
					})
					.catch(error => {
						handleError(error, messages.errorListData);
					});
			} catch (e) {
				showErrorMessage('Ocorreu uma falha ao listar os produtos.');
			}
		},
		byKey: function(key) {
			try {
				return API.get('/products/' + key)
					.then(response => {
						return response.data;
					})
					.catch(error => {
						handleError(error, messages.errorListData);
					});
			} catch (e) {
				showErrorMessage('Ocorreu uma falha ao retornar o produtos.');
			}
		},
	}),
});
export const companyShippingDataSource = new DataSource({
	store: new CustomStore({
		key: 'Id',
		load: function(loadOptions) {
			try {
				return API.get('/shippingCompanies', {
					params: {
						term: loadOptions.searchValue,
						enabled: true,
					},
				})
					.then(response => {
						return response.data.shippingCompanies;
					})
					.catch(error => {
						handleError(error, messages.errorListData);
					});
			} catch (e) {
				showErrorMessage('Ocorreu uma falha ao listar as transportadoras.');
			}
		},
		byKey: function(key) {
			try {
				return API.get('/shippingCompanies/' + key)
					.then(response => {
						return response.data;
					})
					.catch(error => {
						handleError(error, messages.errorListData);
					});
			} catch (e) {
				showErrorMessage('Ocorreu uma falha ao retornar o produtos.');
			}
		},
	}),
});
